// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tn-a11y-toggle {
  position: fixed;
  bottom: max(20px, env(safe-area-inset-bottom));
  left: max(20px, env(safe-area-inset-left));
  z-index: 9500;
  border-radius: 999px;
  width: 44px;
  height: 44px;
  border: 1px solid rgba(0, 31, 63, 0.18);
  background: #fff;
  color: #001F3F;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
}

.tn-a11y-toggle:hover { background: #f4f6f8; }

.tn-a11y-panel {
  position: fixed;
  bottom: calc(max(20px, env(safe-area-inset-bottom)) + 56px);
  left: max(20px, env(safe-area-inset-left));
  width: min(320px, calc(100vw - 40px));
  background: #fff;
  color: #1f2937;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.25);
  padding: 18px;
  z-index: 9501;
  font-family: 'Inter', sans-serif;
  animation: tn-a11y-rise 0.18s ease-out;
}

@keyframes tn-a11y-rise {
  from { transform: translateY(8px); opacity: 0; }
  to   { transform: translateY(0);   opacity: 1; }
}

.tn-a11y-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.tn-a11y-panel__head h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #001F3F;
}

.tn-a11y-panel__close {
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.tn-a11y-panel__group {
  border: none;
  padding: 0;
  margin: 0 0 14px;
}

.tn-a11y-panel__group legend {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: #6b7280;
  margin-bottom: 6px;
}

.tn-a11y-panel__row {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
}

.tn-a11y-panel__hint {
  font-size: 11px;
  color: #6b7280;
  margin: 4px 0 0;
  line-height: 1.45;
}

.tn-a11y-panel__hint code {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  background: #f3f4f6;
  padding: 1px 4px;
  border-radius: 3px;
}

.tn-a11y-panel__seg {
  display: flex;
  gap: 4px;
  background: #f3f4f6;
  border-radius: 6px;
  padding: 3px;
}

.tn-a11y-panel__seg-btn {
  flex: 1 1;
  border: none;
  background: transparent;
  padding: 6px 10px;
  font-size: 13px;
  border-radius: 4px;
  cursor: pointer;
  color: #4b5563;
  font-family: inherit;
}

.tn-a11y-panel__seg-btn.is-active {
  background: #fff;
  color: #001F3F;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-weight: 600;
}

.tn-a11y-panel__reset {
  margin-top: 8px;
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px;
  background: transparent;
  color: #4b5563;
  font-size: 12px;
  cursor: pointer;
  font-family: inherit;
}

.tn-a11y-panel__reset:hover { border-color: #9ca3af; color: #1f2937; }

/* Global hook: user-toggled reduce-motion overrides system preference */
html[data-tn-reduce-motion] *,
html[data-tn-reduce-motion] *::before,
html[data-tn-reduce-motion] *::after {
  animation-duration: 0.001ms !important;
  animation-iteration-count: 1 !important;
  transition-duration: 0.001ms !important;
  scroll-behavior: auto !important;
}

/* Global hook: high-contrast bias for dark backgrounds */
html[data-tn-high-contrast] body { color: #fff; }
html[data-tn-high-contrast] a    { color: #80ffe6; }

/* Global font scale hook. Pages opt in by reading var(--tn-font-scale)
   on their body font-size; absent overrides keep current sizing. */
html { --tn-font-scale: 1; }
`, "",{"version":3,"sources":["webpack://./src/components/A11ySettings/A11ySettings.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,8CAA8C;EAC9C,0CAA0C;EAC1C,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,0CAA0C;AAC5C;;AAEA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,eAAe;EACf,2DAA2D;EAC3D,0CAA0C;EAC1C,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,OAAO,0BAA0B,EAAE,UAAU,EAAE;EAC/C,OAAO,wBAAwB,IAAI,UAAU,EAAE;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA,8BAA8B,qBAAqB,EAAE,cAAc,EAAE;;AAErE,wEAAwE;AACxE;;;EAGE,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,yDAAyD;AACzD,mCAAmC,WAAW,EAAE;AAChD,mCAAmC,cAAc,EAAE;;AAEnD;mEACmE;AACnE,OAAO,kBAAkB,EAAE","sourcesContent":[".tn-a11y-toggle {\n  position: fixed;\n  bottom: max(20px, env(safe-area-inset-bottom));\n  left: max(20px, env(safe-area-inset-left));\n  z-index: 9500;\n  border-radius: 999px;\n  width: 44px;\n  height: 44px;\n  border: 1px solid rgba(0, 31, 63, 0.18);\n  background: #fff;\n  color: #001F3F;\n  font-family: 'Inter', sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);\n}\n\n.tn-a11y-toggle:hover { background: #f4f6f8; }\n\n.tn-a11y-panel {\n  position: fixed;\n  bottom: calc(max(20px, env(safe-area-inset-bottom)) + 56px);\n  left: max(20px, env(safe-area-inset-left));\n  width: min(320px, calc(100vw - 40px));\n  background: #fff;\n  color: #1f2937;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.25);\n  padding: 18px;\n  z-index: 9501;\n  font-family: 'Inter', sans-serif;\n  animation: tn-a11y-rise 0.18s ease-out;\n}\n\n@keyframes tn-a11y-rise {\n  from { transform: translateY(8px); opacity: 0; }\n  to   { transform: translateY(0);   opacity: 1; }\n}\n\n.tn-a11y-panel__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.tn-a11y-panel__head h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #001F3F;\n}\n\n.tn-a11y-panel__close {\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.tn-a11y-panel__group {\n  border: none;\n  padding: 0;\n  margin: 0 0 14px;\n}\n\n.tn-a11y-panel__group legend {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  color: #6b7280;\n  margin-bottom: 6px;\n}\n\n.tn-a11y-panel__row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.tn-a11y-panel__hint {\n  font-size: 11px;\n  color: #6b7280;\n  margin: 4px 0 0;\n  line-height: 1.45;\n}\n\n.tn-a11y-panel__hint code {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 10px;\n  background: #f3f4f6;\n  padding: 1px 4px;\n  border-radius: 3px;\n}\n\n.tn-a11y-panel__seg {\n  display: flex;\n  gap: 4px;\n  background: #f3f4f6;\n  border-radius: 6px;\n  padding: 3px;\n}\n\n.tn-a11y-panel__seg-btn {\n  flex: 1;\n  border: none;\n  background: transparent;\n  padding: 6px 10px;\n  font-size: 13px;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #4b5563;\n  font-family: inherit;\n}\n\n.tn-a11y-panel__seg-btn.is-active {\n  background: #fff;\n  color: #001F3F;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  font-weight: 600;\n}\n\n.tn-a11y-panel__reset {\n  margin-top: 8px;\n  width: 100%;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 8px;\n  background: transparent;\n  color: #4b5563;\n  font-size: 12px;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.tn-a11y-panel__reset:hover { border-color: #9ca3af; color: #1f2937; }\n\n/* Global hook: user-toggled reduce-motion overrides system preference */\nhtml[data-tn-reduce-motion] *,\nhtml[data-tn-reduce-motion] *::before,\nhtml[data-tn-reduce-motion] *::after {\n  animation-duration: 0.001ms !important;\n  animation-iteration-count: 1 !important;\n  transition-duration: 0.001ms !important;\n  scroll-behavior: auto !important;\n}\n\n/* Global hook: high-contrast bias for dark backgrounds */\nhtml[data-tn-high-contrast] body { color: #fff; }\nhtml[data-tn-high-contrast] a    { color: #80ffe6; }\n\n/* Global font scale hook. Pages opt in by reading var(--tn-font-scale)\n   on their body font-size; absent overrides keep current sizing. */\nhtml { --tn-font-scale: 1; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
